import React from 'react';
import PianoRoll from './PianoRoll';


function OperationControls({operation, setOperation}) {

    if (!operation) {
        return (<div>Select operation

            <select>
                <option>Transpose</option>
            </select>
            </div>
        )
    }

    return (<div>
        Transpose
        <input type="number" value={0} />
    </div>)
}

function PianoRollOperationContainer({readonly}) {

    const [sourceHNG, setSourceHNG] = React.useState(null);
    const [operation, setOperation] = React.useState(null);
    const [resultHNG, setResultHNG] = React.useState(null);

    return (<div className="piano-roll-operation-container">
        <PianoRoll data={ {noteGroups: sourceHNG}} readonly={ readonly }/>

        <div className="piano-roll-operation">
            <OperationControls operation={operation} setOperation={setOperation} />
        </div>
        { resultHNG ? <PianoRoll data={ {noteGroups: resultHNG}}/> : null }

    </div>)
}

export default PianoRollOperationContainer;